import React from 'react';
import PropTypes from 'prop-types';
import { Input, TextArea, Label, Checkbox } from 'semantic-ui-react';
import { getTranslatedPlaceholder } from "../../utils/genericUtils";
import { debounce } from 'lodash-es';
import i18n from "i18next";

class InputWrapper extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value
    };
    this.onChange = this.handleChange.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.value !== prevProps.value) {
      this.updateValue();
    }
  }

  componentDidMount() {
    this.updateValue();
  }

  updateValue = () => {
    this.setState({
      value: this.props.value
    });
  };

  /**
   * stores change in it's sate and propagates change to parent
   * @param e
   */
  handleChange(e) {
    this.setState({
      value: this.props.type.toUpperCase() !== 'CHECKBOX' ? e.target.value : e.target.checked
    });
    e.persist();
    this.debouncedOnChange(e);
  }

  onChange = e => {
    this.props.setFieldValue(
        this.props.name,
        this.props.type.toUpperCase() !== 'CHECKBOX' ? e.target.value : e.target.checked
    );
    if (this.props.onChange) this.props.onChange(e);
  };

  //performance improvement
  debouncedOnChange = debounce(this.onChange, 200);

  renderCustomLabel = customLabel => {
    if (customLabel) {
      return <Label content={customLabel} />;
    }
  };

  getTranslatedInputLabel = () => {
    const { t, inputLabel } = this.props;
    if (inputLabel && i18n.exists(inputLabel.content)) inputLabel.content = t(inputLabel.content);
    return inputLabel;
  };

  getInput = () => {
    const {
      name,
      placeholder,
      type,
      disabled,
      step,
      t,
      customLabel,
      label,
      inputLabelPosition,
      inputClassName,
      min,
      icon,
      iconPosition,
			input
    } = this.props;

    return (
        <>
          {this.renderCustomLabel(customLabel)}
          <Input
              label={this.getTranslatedInputLabel()}
              labelPosition={inputLabelPosition}
              fluid
              id={name}
              name={name}
              type={type}
              placeholder={getTranslatedPlaceholder(label, placeholder, t)}
              disabled={disabled}
              step={step}
              onChange={this.onChange}
              value={this.state.value}
              autoComplete="off"
              className={inputClassName}
              min={min}
              icon={icon}
              iconPosition={iconPosition}
							input={input}
          />
        </>
    );
  };

  getTextArea = () => {
    const { name, placeholder, label, rows, disabled, t, inputClassName, input } = this.props;
    return (
        <TextArea
            id={name}
            name={name}
            onChange={this.onChange}
            placeholder={getTranslatedPlaceholder(label, placeholder, t)}
            value={this.state.value}
            disabled={disabled}
            rows={rows}
            className={inputClassName}
						{...input}
        />
    );
  };

  getCheckbox = () => {
    const { name,label, disabled, toggle, inputClassName, id } = this.props;
    return (
        <Checkbox
            id={id || name}
            name={name}
            onChange={this.onChange}
            checked={this.state.value}
            disabled={disabled}
            toggle={toggle}
            className={inputClassName}
        />
    );
  };

  render() {
    const { type } = this.props;
    if (type.toUpperCase() === 'TEXTAREA') {
      return this.getTextArea();
    } else if (type.toUpperCase() === 'CHECKBOX') {
      return this.getCheckbox();
    } else {
      return this.getInput();
    }
  }
}

InputWrapper.propTypes = {
  name: PropTypes.string,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  disabled: PropTypes.bool
};

InputWrapper.defaultProps = {
  name: '',
  type: 'text',
  disabled: false,
  placeholder: '',
  customLabel: false,
  setFieldValue: () => {}
};

export default InputWrapper;
